import { classnames } from '@aibees/shared/utils';
import { mergeSx } from 'merge-sx';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { MissingDataProps as Props } from './types';

export const MissingData = memo(({ className, message, sx }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('MissingData', className)}
      sx={mergeSx(SX.root, sx)}
    >
      {message}
    </Styled.Wrapper>
  );
});

MissingData.displayName = 'MissingData';
